import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ConfirmDialog = ({ open, onOpenChange, title, description, onConfirm, destructive = false }) => {
  const handleConfirm = async (e) => {
    e.preventDefault();
    await onConfirm();
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="brutalist-card border-2 border-[#0A0A0A]">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="confirm-dialog-title">{title || "Are you sure?"}</AlertDialogTitle>
          <AlertDialogDescription>{description || "This action cannot be undone."}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="brutalist-btn-secondary" data-testid="confirm-cancel-btn">Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className={destructive ? "bg-[#FF6B6B] text-white hover:bg-[#e55555] border-2 border-[#0A0A0A]" : "brutalist-btn-primary"}
            data-testid="confirm-action-btn"
          >
            Confirm
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
